import { bool, number, oneOf, string, shape } from 'prop-types';
import React from 'react';
import AmpImg from 'components/AmpImg';
import AmpHtml from 'components/AmpHtml';
import styles from './styles';

export default function AmpSideBySide({
  image,
  html,
  variant,
  isAffiliate,
  hasPrism
}) {
  const imageProps = {
    ...image,
    ...(variant === 'small'
      ? {
          // Small
          maxSize: {
            width: 100,
            aspectRatio: 1
          },
          isFixedSize: true,
          hasPrism: false,
          isPinnable: false,
          // TEMP: override caption and credit so it doesn't show. We should
          // rework Figure to take a hideInfo prop and use this for the interrupter
          // as well.
          caption: undefined,
          credit: undefined,
          // TEMP: fix issue where originalWidth and originalHeight values prevent
          // aspectRatio from being overridden in AmpImg
          originalWidth: null,
          originalHeight: null
        }
      : {
          // Large
          hasPrism,
          maxSize: {
            width: 167
          }
        }),
    ...{
      placement: 'sideBySide',
      isAffiliate
      // post
    }
  };
  return (
    <div className={`AmpSideBySide AmpSideBySide--${variant}`}>
      <AmpImg {...imageProps} />
      <AmpHtml html={html} isAffiliate={isAffiliate} />
      <style jsx>{styles}</style>
    </div>
  );
}

AmpSideBySide.defaultProps = {
  html: '',
  image: {},
  isAffiliate: false,
  hasPrism: false,
  variant: 'large'
};

AmpSideBySide.propTypes = {
  html: string,
  image: shape({
    url: string,
    alt: string,
    caption: string,
    href: string,
    isPinnable: bool,
    originalWidth: number,
    originalHeight: number
  }),
  variant: oneOf(['small', 'large']),
  isAffiliate: bool,
  hasPrism: bool
};
